import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private _menuClicked = false;
  private _menuPath: string | null = null;

  setMenuClicked(value: boolean, path?: string): void {
    this._menuClicked = value;
    this._menuPath = path ?? null;
  }

  consumeMenuClicked(): { clicked: boolean; path: string | null}  {
    const result = { clicked: this._menuClicked, path: this._menuPath };
    this._menuClicked = false;
    this._menuPath = null;
    return result;
  }
}
